import { FC, useMemo } from "react";
import { IWidgetTemplate } from "../../../interfaces/widget-template";
import { ReachClick } from "../../../utils/core";

const LOGO_MARK = `${process.env.PUBLIC_URL}/images/logos/logo-mark.webp`;

const WidgetTemplate7: FC<IWidgetTemplate> = ({ company, theme }) => {
  const companyId = company?.companyId;

  const payload = useMemo(
    () => ({ companyId, widgetId: 7 as const }),
    [companyId],
  );

  const companyUrl = useMemo(
    () =>
      `https://www.trustfinance.com/companies/${companyId}?utm_source=widget&utm_medium=banner&utm_campaign=micro-review-count`,
    [companyId],
  );

  return (
    <a
      className="text-decoration-none"
      style={{ color: theme === "dark" ? "#c4c4c4" : "unset" }}
      href={companyUrl}
      target="_blank"
      rel="noreferrer noopener"
      onClick={() => ReachClick(payload)}
    >
      <div className="overflow-hidden d-flex justify-content-center">
        <div className="fs-16 d-flex align-items-center p-2">
          See our reviews on
        </div>
        <div className="d-flex align-items-center txt p-2">
          <img src={LOGO_MARK} alt="TrustFinance" width={19} height={19} />
          <span className="fs-16">TrustFinance</span>
        </div>
      </div>
    </a>
  );
};

export default WidgetTemplate7;
